import React, { useEffect } from 'react';
import { Box, Container, Text, Link } from '@chakra-ui/react';
import Head from 'next/head';

export default function Terms() {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://app.termly.io/embed-policy.min.js';
      script.id = 'termly-jssdk';
      script.async = true;

      const firstScriptTag = document.getElementsByTagName('script')[0];
      if (firstScriptTag && firstScriptTag.parentNode) {
        firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
      }

      return () => {
        // Cleanup the script when the component is unmounted
        const termlyScript = document.getElementById('termly-jssdk');
        if (termlyScript) {
          termlyScript.remove();
        }
      };
    }
  }, []);

  return (
    <>
      <Head>
        <title>Terms</title>
        <meta name="description" content="Terms of Service" />
      </Head>
      <main>
        <Container>
          <Box py={2}>
            <Text paddingBottom={4} noOfLines={2} paddingTop={4}>
              For specifics pertaining to transactions, please review{' '}
              <Link textColor="blue" href="/transaction_terms">
                Transaction Terms
              </Link>
            </Text>

            {/* @ts-ignore */}
            <div name="termly-embed" data-id="002fb587-4ead-46e0-b638-42d23717a667"></div>
          </Box>
        </Container>
      </main>
    </>
  );
}
